<template>
  <DsShowcase title="TextPlay" description="Componente de texto tipográfico. Controla tamanho, peso, cor, tag HTML, line-clamp e decoração.">
    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'xxs' | 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | '8xl' | '9xl'</code></p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <TextPlay text="xxs — 0.625rem" size="xxs" />
        <TextPlay text="xs — 0.75rem" size="xs" />
        <TextPlay text="sm — 0.875rem" size="sm" />
        <TextPlay text="base — 1rem" size="base" />
        <TextPlay text="lg — 1.125rem" size="lg" />
        <TextPlay text="xl — 1.25rem" size="xl" />
        <TextPlay text="2xl — 1.5rem" size="2xl" />
        <TextPlay text="3xl — 1.875rem" size="3xl" />
        <TextPlay text="4xl — 2.25rem" size="4xl" />
      </div>
    </section>

    <!-- PROP: weight -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">weight</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'thin' | 'extralight' | 'light' | 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold' | 'black'</code></p>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <TextPlay text="Thin (100)" weight="thin" size="lg" />
        <TextPlay text="Extra Light (200)" weight="extralight" size="lg" />
        <TextPlay text="Light (300)" weight="light" size="lg" />
        <TextPlay text="Normal (400)" weight="normal" size="lg" />
        <TextPlay text="Medium (500)" weight="medium" size="lg" />
        <TextPlay text="Semibold (600)" weight="semibold" size="lg" />
        <TextPlay text="Bold (700)" weight="bold" size="lg" />
        <TextPlay text="Extra Bold (800)" weight="extrabold" size="lg" />
        <TextPlay text="Black (900)" weight="black" size="lg" />
      </div>
    </section>

    <!-- PROP: color -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">color</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — qualquer cor CSS. Padrão: <code>var(--fontcolor)</code></p>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <TextPlay text="Cor padrão (--fontcolor)" size="lg" />
        <TextPlay text="Vermelho" size="lg" color="#e53e3e" />
        <TextPlay text="Verde" size="lg" color="#38a169" />
        <TextPlay text="Azul" size="lg" color="#3182ce" />
        <TextPlay text="Roxo" size="lg" color="#7c3aed" />
      </div>
    </section>

    <!-- PROP: tag -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">tag</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'p' | 'span' | 'label' | 'strong' | 'div' | 'h1' | 'a'</code> — padrão: <code>p</code></p>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <TextPlay tag="h1" text="Renderizado como <h1>" size="2xl" weight="bold" />
        <TextPlay tag="p" text="Renderizado como <p>" />
        <TextPlay tag="span" text="Renderizado como <span>" />
        <TextPlay tag="strong" text="Renderizado como <strong>" />
      </div>
    </section>

    <!-- PROP: decoration -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">decoration</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'none' | 'underline' | 'line-through'</code></p>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <TextPlay text="Sem decoração" size="lg" decoration="none" />
        <TextPlay text="Sublinhado" size="lg" decoration="underline" />
        <TextPlay text="Riscado" size="lg" decoration="line-through" />
      </div>
    </section>

    <!-- PROP: lineClamp -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">lineClamp</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — limita o número de linhas exibidas</p>
      <div class="tw:max-w-md">
        <TextPlay
          :line-clamp="2"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum."
        />
      </div>
    </section>

    <!-- PROP: skeleton / disabled -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton / disabled</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-2">
        <TextPlay text="Texto com skeleton" :skeleton="true" size="lg" />
        <TextPlay text="Texto desabilitado" :disabled="true" size="lg" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { TextPlay } from '@/components/atomic'
</script>
